import { create } from 'zustand';
// Removed TypeScript imports: import { BaseState, StoreConfig } from '../types/store';
import { storeManager } from './storeManager';
import { useTabStore } from './tabStore';

export function createStore(config) {
  // Default scope to 'tab' for backward compatibility
  const scope = config.cache?.scope || 'tab';

  const store = create((set, get) => {
    if (scope === 'global') {
      return {
        ...config.initialState,
        ...config.methods(set, get)
      };
    }
    const wrappedGet = () => {
      if (config.cache?.tabBehavior === 'persist') {
        const { activeTabId } = useTabStore.getState();
        if (activeTabId) {
          const cachedState = storeManager.getTabState(config.id, activeTabId);
          if (cachedState) {
            return cachedState;
          } else {
            return config.initialState;
          }
        }
      }
      return get();
    };

    const wrappedSet = (updates) => {
      const newState = { ...wrappedGet(), ...updates };

      if (config.cache?.tabBehavior === 'persist') {
        const { activeTabId } = useTabStore.getState();
        if (activeTabId) {
          storeManager.setTabState(config.id, activeTabId, newState);
        }
      }

      set(newState);
    };

    return {
      ...config.initialState,
      ...config.methods(wrappedSet, wrappedGet),
      _metadata: {
        lastAccessed: Date.now(),
        lastUpdated: Date.now(),
        tabId: null,
        lastResetTab: null
      }
    };
  });

  // Register store with manager
  storeManager.registerStore(config.id, store, config);

  // Add method to clear tab state (only relevant for tab-scoped stores)
  if (scope === 'tab') {
    store.clearTabState = (tabId) => {
      if (config.cache?.tabBehavior === 'persist') {
        storeManager.clearTabState(config.id, tabId);
      }
    };
  }

  // console.log(store);

  return store;
}
